import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SatInput from '@components/common/satUI/SatInput';
import SecurityInput from '@components/common/biz/SecurityInput';
import { updateRegisterCustomerInfo } from '@store/actions/registerAction';

const RegisterInput = props => {
  const { formData = {}, setFormProps = () => {} } = props;
  const dispatch = useDispatch();

  const handleInputEvent = (value, targetId) => {
    if (targetId === 'customerName') {
      dispatch(
        updateRegisterCustomerInfo({
          customerName: value,
        }),
      );
    } else if (targetId === 'rsdn1') {
      dispatch(
        updateRegisterCustomerInfo({
          rsdn1: value,
        }),
      );
    } else if (targetId === 'rsdn2') {
      dispatch(
        updateRegisterCustomerInfo({
          rsdn2: value,
        }),
      );
    } else if (targetId === 'rsdnSecurityObj') {
      dispatch(
        updateRegisterCustomerInfo({
          rsdnSecurityObj: value,
        }),
      );
    }
  };

  // 변경
  return (
    <>
      <SatInput
        value={formData.userName}
        type="text"
        label="고객명"
        border
        onChange={value => setFormProps('userName', value)}
      />
      <div className="item-number">
        <SatInput
          border
          value={formData.rsdn?.substring(0, 6)}
          type="number"
          label="주민등록번호"
          numberPadTitle="주민번호 앞6자리"
          maxLength={6}
          readOnly
        />
        <span className="hypen">-</span>
        <SatInput
          border
          readOnly
          isPrivacy
          isShowFirstLetter
          isRandomPad
          value={formData.rsdn?.substring(6)}
          type="number"
          label="뒤7자리"
          numberPadTitle="주민번호 뒤7자리"
          maxLength={7}
        />
      </div>
      <SatInput
        value={formData.mobileTelNo}
        type="number"
        label="휴대전화번호"
        maxLength={11}
        border
        useMobile
        onChange={value => setFormProps('mobileTelNo', value)}
      />
    </>
  );
};

export default RegisterInput;
